import api from '../lib/api'

export const getTenant = (tenantId) =>
  api.get(`/admin/tenants/${tenantId}`).then(r => r.data)

export const updateTenant = (tenantId, updates) =>
  api.patch(`/admin/tenants/${tenantId}`, updates).then(r => r.data)

export const getGrowCrmConfig = (tenantId) =>
  api.get(`/admin/tenants/${tenantId}/growcrm-config`).then(r => r.data)

export const updateGrowCrmConfig = (tenantId, patch) =>
  api.patch(`/admin/tenants/${tenantId}/growcrm-config`, patch).then(r => r.data)

export const getChannelBotSettings = (tenantId) =>
  api.get(`/manager/${tenantId}/channels/bot-settings`).then(r => r.data)

export const updateChannelBotSetting = (tenantId, channel, enabled) =>
  api.patch(`/manager/${tenantId}/channels/${channel}/bot`, { enabled }).then(r => r.data)

export const generateGrowCrmSecret = (tenantId, kind) =>
  api.post(`/admin/tenants/${tenantId}/growcrm-config/generate-secret`, { kind }).then(r => r.data)

export const testGrowCrmConfig = (tenantId) =>
  api.post(`/admin/tenants/${tenantId}/growcrm-config/test`).then(r => r.data)

export const getReports = (tenantId) =>
  api.get(`/admin/tenants/${tenantId}/reports`).then(r => r.data)

export const getTenantSpeakbotConfig = (tenantId) =>
  api.get(`/admin/tenants/${tenantId}/speakbot-config`).then(r => r.data)

export const updateTenantSpeakbotConfig = (tenantId, patch) =>
  api.patch(`/admin/tenants/${tenantId}/speakbot-config`, patch).then(r => r.data)

export const getKbDocuments = (tenantId, botType = 'chatizi') =>
  api.get(`/admin/kb/documents/${tenantId}`, { params: { bot_type: botType } }).then(r => r.data)

export const deleteKbDocument = (docId) =>
  api.delete(`/admin/kb/documents/${docId}`).then(r => r.data)

export const ingestKbUrl = (tenantId, url, botType = 'chatizi') =>
  api.post('/admin/kb/ingest/url', { tenant_id: tenantId, url, bot_type: botType }).then(r => r.data)

export const ingestKbUrls = (tenantId, urls) =>
  api.post(`/admin/tenants/${tenantId}/kb/ingest-urls`, { urls }).then(r => r.data)

export const uploadKbFile = (tenantId, { file, docType, title, botType = 'chatizi' }) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('tenant_id', tenantId)
  formData.append('doc_type', docType)
  formData.append('title', title)
  formData.append('bot_type', botType)
  return api.post('/admin/kb/documents/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data)
}

export const getBillingStatus = (tenantId) =>
  api.get(`/billing/${tenantId}/status`).then(r => r.data)
